import Vue from 'vue'
import Router from 'vue-router'

import Index from 'PAGES/Index.vue'
import Busca from 'PAGES/Busca.vue'
import Album from 'PAGES/Album.vue'
import Contato from 'PAGES/Contato.vue'
import Documento from 'PAGES/Documento.vue'
import Documentos from 'PAGES/Documentos.vue'
import Extra from 'PAGES/Extra.vue'
import Unidades from 'PAGES/Unidades.vue'
import Galeria from 'PAGES/Galeria.vue'
import Generica from 'PAGES/Generica.vue'
import Noticia from 'PAGES/Noticia.vue'
import Noticias from 'PAGES/Noticias.vue'
import Sitemap from 'PAGES/Sitemap.vue'

// import CGTIndex from 'PAGES/cgt/Index.vue'
// import CGTSobre from 'PAGES/cgt/Sobre.vue'
// import CGTInformacoes from 'PAGES/cgt/Informacoes.vue'
// import CGTTelefones from 'PAGES/cgt/Telefones.vue'
// import CGTContato from 'PAGES/cgt/Contato.vue'

// import DCFIndex from 'PAGES/dcf/Index.vue'
// import DCFSobre from 'PAGES/dcf/Sobre.vue'
// import DCFManual from 'PAGES/dcf/Manual.vue'
// import DCFDocumentos from 'PAGES/dcf/Documentos.vue'
// import DCFFormularios from 'PAGES/dcf/Formularios.vue'
// import DCFContato from 'PAGES/dcf/Contato.vue'

import DGCIndex from 'PAGES/dgc/Index.vue'
import DGCSobre from 'PAGES/dgc/Sobre.vue'
// import DGCContratos from 'PAGES/dgc/Contratos.vue'
import DGCOrientacoes from 'PAGES/dgc/Orientacoes.vue'
import DGCContato from 'PAGES/dgc/Contato.vue'

// import DGIIndex from 'PAGES/dgi/Index.vue'
// import DGISobre from 'PAGES/dgi/Sobre.vue'
// import DGIDocumentos from 'PAGES/dgi/Documentos.vue'
// import DGIInformacoes from 'PAGES/dgi/Informacoes.vue'
// import DGIContato from 'PAGES/dgi/Contato.vue'

import DCOMIndex from 'PAGES/dcom/Index.vue'
import DCOMSobre from 'PAGES/dcom/Sobre.vue'
import DCOMAtas from 'PAGES/dcom/Atas.vue'
import DCOMEditais from 'PAGES/dcom/Editais.vue'
import DCOMLegislacoes from 'PAGES/dcom/Legislacoes.vue'
import DCOMContato from 'PAGES/dcom/Contato.vue'
import DCOMOrientacoes from 'PAGES/dcom/Orientacoes.vue'

import Error from 'PAGES/Error'

// import DSPIndex from 'PAGES/dsp/Index.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [

    { name: 'Index', component: Index, path: '/' },
    { name: 'Album', component: Album, path: '/album/:slug?' },
    { name: 'Busca', component: Busca, path: '/busca' },
    { name: 'Categorias', component: Documentos, path: '/documentos' },
    { name: 'Contato', component: Contato, path: '/contato' },
    { name: 'Documentos', component: Documento, path: '/documentos/:slug?' },
    { name: 'Galeria', component: Galeria, path: '/galeria/:page?' },
    { name: 'Generica', component: Generica, path: '/layout' },
    { name: 'Institucional', component: Extra, path: '/institucional/:slug?' },
    { name: 'Unidades', component: Unidades, path: '/unidades' },
    { name: 'Noticia', component: Noticia, path: '/noticia/:id?' },
    { name: 'Noticias', component: Noticias, path: '/noticias/:page?/:tag?' },
    { name: 'Sitemap', component: Sitemap, path: '/sitemap' },

    // { name: 'CGTIndex', component: CGTIndex, path: '/cgt' },
    // { name: 'CGTSobre', component: CGTSobre, path: '/cgt/sobre' },
    // { name: 'CGTInformacoes', component: CGTInformacoes, path: '/cgt/informacoes' },
    // { name: 'CGTTelefones', component: CGTTelefones, path: '/cgt/telefones' },
    // { name: 'CGTContato', component: CGTContato, path: '/cgt/contato' },

    // { name: 'DCFIndex', component: DCFIndex, path: '/dcf' },
    // { name: 'DCFSobre', component: DCFSobre, path: '/dcf/sobre' },
    // { name: 'DCFManual', component: DCFManual, path: '/dcf/manual-de-diarias' },
    // { name: 'DCFCategorias', component: DCFDocumentos, path: '/dcf/documentos' },
    // { name: 'DCFArquivos', component: DCFDocumentos, path: '/dcf/documentos/:id' },
    // { name: 'DCFFormularios', component: DCFFormularios, path: '/dcf/formularios' },
    // { name: 'DCFContato', component: DCFContato, path: '/dcf/contato' },

    { name: 'DGCIndex', component: DGCIndex, path: '/dgc' },
    { name: 'DGCSobre', component: DGCSobre, path: '/dgc/sobre' },
    // { name: 'DGCContratos', component: DGCContratos, path: '/dgc/contratos' },
    { name: 'DGCOrientacoes', component: DGCOrientacoes, path: '/dgc/orientacoes-e-manuais' },
    { name: 'DGCContato', component: DGCContato, path: '/dgc/contato' },

    // { name: 'DGIIndex', component: DGIIndex, path: '/dgi' },
    // { name: 'DGISobre', component: DGISobre, path: '/dgi/sobre' },
    // { name: 'DGICategorias', component: DGIDocumentos, path: '/dgi/documentos' },
    // { name: 'DGIArquivos', component: DGIDocumentos, path: '/dgi/documentos/:id' },
    // { name: 'DGIInformacoes', component: DGIInformacoes, path: '/dgi/informacoes' },
    // { name: 'DGIContato', component: DGIContato, path: '/dgi/contato' },

    { name: 'DCOMIndex', component: DCOMIndex, path: '/dcom' },
    { name: 'DCOMSobre', component: DCOMSobre, path: '/dcom/sobre' },
    { name: 'DCOMAtas', component: DCOMAtas, path: '/dcom/atas' },
    { name: 'DCOMEditais', component: DCOMEditais, path: '/dcom/editais/:page?' },
    { name: 'DCOMLegislacoes', component: DCOMLegislacoes, path: '/dcom/legislacoes' },
    { name: 'DCOMContato', component: DCOMContato, path: '/dcom/contato' },
    { name: 'DCOMOrientacoes', component: DCOMOrientacoes, path: '/dcom/orientacoes-e-manuais/:page?' },

    { path: '*', name: 'Error', component: Error }

    // { name: 'DSPIndex', component: DSPIndex, path: '/dsp' }

  ]
})



// WEBPACK FOOTER //
// ./src/js/router/index.js